function Stages6() {
	return ( 
		<div>
			<div>
				<p>
					Nach 10 Jahren ist der Stamm weich.
				</p>
			</div>
		</div>
	 );
}

export default Stages6;